<template>
<div class="vsd420">
  <Head></Head>
  <div style="width: 100%; height: calc(100vh - 6.225rem); position: absolute" class="flex_1">
    <Simulation
      :model-list="modelList"
      :show-view="showView"
      :markeData="markeData"
      :currentState="currentState"
    ></Simulation>
    <transition name="shop-transform" mode="out-in">
      <OnlineShop v-if="onlineShop" :onlineShop="onlineShop"></OnlineShop>
    </transition>
    <Control
      :onlineShop="onlineShop"
      :choose-controls="chooseControls"
    ></Control>
</div>
</div>
</template>
<script>
import Simulation from "@/components/devices/Simulation/Index"
import OnlineShop from "@/components/devices/VSD420-OnlineShop/Index"
import Control from "@/components/devices/Control"
let list = [
  "http://52.83.66.102:5011/public/VSD420/干泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗茨泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵.glb",
  "http://52.83.66.102:5011/public/VSD420/干泵-罗杆泵电机.glb",
  "http://52.83.66.102:5011/public/VSD420/simulation/罗茨泵电机球.glb",
  "http://52.83.66.102:5011/public/VSD420/simulation/螺杆泵球.glb",
  "http://52.83.66.102:5011/public/VSD420/simulation/螺杆泵电机球.glb"
];
import _ from "lodash";

export default {
  name: "vsd420-O",
  data() {
    return {
      chooseControls: 6,
      onlineShop: false,
      showView: true,
      modelList: list,
      markeData: [],
      timer: null,
      timer1: null,
      currentState: "normal",
      torque: "24"
    };
  },
  computed: {
    VSD420() {
      return {
        lcb: [
          {
            label: this.$t("Cooling water flow"),
            value: "1.9",
            unit: "L/min"
          },
          {
            label: this.$t("Cooling water temperature"),
            value: "30",
            unit: "℃"
          },
          {
            label: this.$t("X-directional vibration"),
            value: "3.5",
            unit: "mm/s"
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "6.2",
            unit: "mm/s"
          },
          {
            label: this.$t("Inlet pressure"),
            value: "2",
            unit: "mbarA"
          },
          {
            label: this.$t("Inlet temperature"),
            value: "10",
            unit: "℃"
          }
        ],
        lcbdj: [
          {
            label: this.$t("Current"),
            value: "5.82",
            unit: "A"
          },
          {
            label: this.$t("Rotation Speed"),
            value: "2375",
            unit: "rpm"
          },
          {
            label: this.$t("Power consumption"),
            value: "2.1",
            unit: "kW"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "75",
            unit: "℃"
          },
          {
            label: this.$t("X-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          }
        ],
        lgb: [
          {
            label: this.$t("Cooling water flow"),
            value: "10",
            unit: "L/min"
          },
          {
            label: this.$t("Cooling water temperature"),
            value: "30",
            unit: "℃"
          },
          {
            label: this.$t("X-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          },
          {
            label: this.$t("Inlet pressure"),
            value: "9",
            unit: "mbarA"
          },
          {
            label: this.$t("Inlet temperature"),
            value: "70",
            unit: "℃"
          }
        ],
        lgbdj: [
          {
            label: this.$t("Torque"),
            value: "24",
            unit: "N·m"
          },
          {
            label: this.$t("Current"),
            value: "22",
            unit: "A"
          },
          {
            label: this.$t("Rotation Speed"),
            value: "2950",
            unit: "rpm"
          },
          {
            label: this.$t("Power consumption"),
            value: "7.7",
            unit: "kW"
          },
          {
            label: this.$t("Bearing temperature"),
            value: "75",
            unit: "℃"
          },
          {
            label: this.$t("X-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          },
          {
            label: this.$t("Y-directional vibration"),
            value: "2.8",
            unit: "mm/s"
          }
        ]
      };
    }
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.markeData = this.VSD420;
      },
      deep: true
    },
    torque: {
      handler(val) {
        console.log(val);
        /* todo根据纽米值判断status值 29.7 34.5 */
        this.markeData["lgbdj"].forEach(obj => {
          if (obj.label == this.$t("Torque")) {
            obj.value = val;
          }
        });
      },
      deep: true
    },
    currentState(val) {
      console.log("currentState:", val);
    }
  },
  created() {},
  mounted() {
    this.markeData = this.VSD420;
    window.addEventListener("resize", () => {
      window.location.reload();
    });

    this.timer = setInterval(() => {
      this.markeData = this.changeData();
    }, 2000);

    this.timer1 = setInterval(() => {
      this.torque = this.randoms(24, 35);
    }, 10000);
  },
  beforeUnmount() {
    window.removeEventListener("resize", () => {
      window.location.reload();
    });
    if (this.timer) {
      this.timer = null;
    }
    if (this.timer1) {
      this.timer1 = null;
    }
  },
  methods: {
    changeData() {
      let copyData = _.cloneDeep(this.markeData);
      Object.values(copyData).forEach(obj => {
        obj.forEach(data => {
          if (data.label != this.$t("Torque")) {
            if (data.label == this.$t("Power consumption")) {
              data.value = this.randoms(
                Number(data.value),
                Number(data.value) + 0.1
              );
            } else {
              data.value = this.randoms(
                Number(data.value),
                Number(data.value) + 1
              );
            }
          }
        });
      });
      return copyData;
    },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    }
  },
  components: {
    Simulation,
    OnlineShop,
    Control
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/scss/common.scss");

.vsd420 {
 width: 100%;
  height: 100vh;
  position: relative;
  font-size: 16px;
  background-image:radial-gradient(circle at 32% 52%, #2f5278,#081E38,#071729);
  color: #fff;
}
</style>
